// Copyright (C) Unite Digital LLC - All Rights Reserved.
// Unauthorized copying of this file, via any medium is strictly prohibited.
// Proprietary and confidential.
// Developed by Unite Digital LLC.

import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable, map } from 'rxjs';
import { TemplateState } from '@interfaces/document.interfaces';
import { ModalSize } from '@interfaces/shared.interfaces';

@Injectable({ providedIn: 'root' })
export class SharedService {
    constructor(private readonly apiService: ApiService) {}

    getStateTerritoryList(): Observable<TemplateState[]> {
        return this.apiService.getV2$<TemplateState[]>('api/ui/stateTerritorylist').pipe(map((res) => res.data));
    }

    getHelpPanelContent(): Observable<any> {
        return this.apiService.getV2$('api/File/GetAllHelpContent').pipe(map((res) => res.data));
    }

    getDeviceScreenWidth(): number {
        return window.screen.width;
    }

    getDeviceScreenHeight(): number {
        return window.screen.height;
    }

    getModalWidth(modalSize: ModalSize): number {
        //currently, l is the only size we have using this pattern
        if (modalSize === ModalSize.Large) {
            if (this.getDeviceScreenWidth() > 1050) {
                return 900;
            } else if (this.getDeviceScreenWidth() > 700) {
                return 650;
            } else {
                return 400;
            }
        }
        if (modalSize === ModalSize.Medium) {
            if (this.getDeviceScreenWidth() > 1050) {
                return 700;
            } else if (this.getDeviceScreenWidth() > 700) {
                return 650;
            } else {
                return 400;
            }
        } else {
            return 900;
        }
    }

    getModalHeight(modalSize: ModalSize): number {
        //currently, l is the only size we have using this pattern
        if (modalSize === ModalSize.Large) {
            return this.getDeviceScreenHeight() - 150;
        }
        if (modalSize === ModalSize.Medium) {
            if (this.getDeviceScreenHeight() < 800) {
                return this.getDeviceScreenHeight() - 100;
            } else {
                return 700;
            }
        } else {
            return 900;
        }
    }

    getModalInnerContentWidth(modalSize: ModalSize): number {
        return this.getModalWidth(modalSize) - 40;
    }

    getModalInnerContentHeight(modalSize: ModalSize): number {
        return this.getModalHeight(modalSize) - 100;
    }
}
